<template>
  <section class="section">
    <div class="container">
      <BaseTitle>
        Mot de passe oublié
      </BaseTitle>

      <form
        class="max-w-md m-auto"
        @submit.prevent="submit"
      >
        <b-field
          class="mb-8"
          label="Email"
        >
          <b-input
            v-model="email"
            type="email"
            placeholder="email"
            required
          />
        </b-field>
        <div class="text-center">
          <b-button
            type="is-primary"
            native-type="submit"
            class="mb-4"
          >
            Valider
          </b-button>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BaseTitle from '../components/BaseTitle.vue';

export default {
  name: 'ForgotPassword',
  components: {
    BaseTitle,
  },
  data() {
    return {
      email: '',
    };
  },
  computed: {
    ...mapGetters('authentication', ['connected']),
  },
  methods: {
    ...mapActions('authentication', ['sendResetPasswordInstructions']),
    submit() {
      this.sendResetPasswordInstructions({ email: this.email })
        .then(() => {
          const message = 'Votre demande a bien été prise en compte. Un email contenant les instructions vous sera envoyé si nous trouvons un utilisateur correspondant.';
          this.$buefy.toast.open({
            message,
            type: 'is-success',
            position: 'is-bottom',
            duration: 5000,
          });
        });
    },
  },
};
</script>
